import { render, staticRenderFns } from "./ReCallsObjTable.vue?vue&type=template&id=31477b2e&scoped=true"
import script from "./ReCallsObjTable.vue?vue&type=script&lang=js"
export * from "./ReCallsObjTable.vue?vue&type=script&lang=js"
import style0 from "./ReCallsObjTable.vue?vue&type=style&index=0&id=31477b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31477b2e",
  null
  
)

export default component.exports